import { MenuItem } from '@mui/material';
import { BaseSelectField } from 'common/components/base-select-field';
import { styleSelect } from 'common/constants';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { questionAnswerOptions } from 'services/campaign.service';
import { ILogicOptions, IQuestionLogicValues } from 'types/campaign';
import { handleError } from 'utils/helpers';

interface AnswerOptionsFieldsProps {
    logicIndex: number;
    values: IQuestionLogicValues[];
}

const AnswerOptionsFields: React.FC<AnswerOptionsFieldsProps> = ({
    logicIndex,
    values,
}) => {
    const { watch, setValue } = useFormContext();
    const questionId = watch(`logics.${logicIndex}.question`);
    const currentCampaignId = Number(useParams().id);
    const [answerOptions, setAnswerOptions] = useState<ILogicOptions[]>([]);

    useEffect(() => {
        const fetchAnswerOptions = async () => {
            try {
                const response = await questionAnswerOptions(
                    currentCampaignId,
                    questionId
                );
                if (response.success) {
                    // toast.success(response.message);
                    setAnswerOptions(response.data.options);
                    if (
                        values.length &&
                        values[logicIndex] &&
                        values[logicIndex].question === questionId
                    ) {
                        setValue(
                            `logics.${logicIndex}.answer`,
                            values[logicIndex].answer
                        );
                    } else {
                        setValue(
                            `logics.${logicIndex}.answer`,
                            response.data.options[0]?.value
                        );
                    }
                } else {
                    // toast.error(response.message);
                }
            } catch (error) {
                handleError(error);
            }
        };
        if (questionId) fetchAnswerOptions();
    }, [questionId, currentCampaignId, logicIndex, setValue, values]);

    return (
        <BaseSelectField
            name={`logics.${logicIndex}.answer`}
            sx={{
                ...styleSelect,
                '& .MuiSelect-icon': {
                    right: '20px',
                    fontSize: '50px ',
                },
            }}
        >
            {answerOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </BaseSelectField>
    );
};

export default AnswerOptionsFields;
